module.exports = __webpack_public_path__ + "img/mercadopago.06773028.png";